import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import './index.scss';

import { onKeyDownFunc } from 'utils';

const notToLinkFunc = e => e.preventDefault();
const toLinkFunc = () => {};

const NextButton = ({ label, onClick, link = '', valid = true }) => {
   
  const onClickFunc = (e) => {
    onClick(e);
  };

  return (
    <Link
      to={link}
      className={clsx('NextButton', { valid })}
      onClick={valid ? toLinkFunc : notToLinkFunc}
      onKeyDown={onKeyDownFunc}
    >
      <button
        className="button"
        type="button"
        onClick={valid ? onClickFunc : () => { console.log('no valid'); }}
      >
        {label}
      </button>
    </Link>
  );
};

export default NextButton;